<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <div>
          <material-card>
            <ValidationObserver ref="form" v-slot="{ passes }">
              <v-form @submit.prevent="passes(filterdata)" class="mb-5">
                <v-card>
                  <v-expansion-panels v-model="panel" multiple focusable>
                    <v-expansion-panel>
                      <v-expansion-panel-header>{{
                        $t("language.filter")
                      }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card-text>
                          <v-container grid-list-xl>
                            <v-layout wrap>
                              <v-flex xs12 sm6 md3>
                                <v-autocomplete
                                  dense
                                  v-model="filter.departmentid"
                                  :items="DepartmentList"
                                  item-text="name"
                                  item-value="id"
                                  :label="$t('language.department')"
                                  :clearable="true"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm6 md3>
                                <v-autocomplete
                                  dense
                                  v-model="filter.branchid"
                                  :items="BranchList"
                                  item-text="name"
                                  item-value="id"
                                  :label="$t('language.branch')"
                                  :clearable="true"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm6 md3>
                                <v-autocomplete
                                  dense
                                  v-model="filter.personid"
                                  :items="PersonList"
                                  item-text="name"
                                  item-value="id"
                                  :label="$t('language.person')"
                                  :clearable="true"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm12 md3>
                                <ValidationProvider
                                  :name="$t('language.fromdate')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <eng-nep-date-picker
                                    :error-messages="errors[0]"
                                    v-model="filter.fromdate"
                                    :label="$t('language.fromdate')"
                                  ></eng-nep-date-picker>
                                </ValidationProvider>
                              </v-flex>
                              <v-flex xs12 sm12 md3>
                                <ValidationProvider
                                  :name="$t('language.todate')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <eng-nep-date-picker
                                    :error-messages="errors[0]"
                                    v-model="filter.todate"
                                    :label="$t('language.todate')"
                                  ></eng-nep-date-picker>
                                </ValidationProvider>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn
                            dense
                            color="general"
                            class="mr-2"
                            light
                            type="submit"
                            >{{ $t("language.filter") }}</v-btn
                          >
                          <v-btn
                            dense
                            class="mr-2"
                            light
                            @click="resetFilter"
                            >{{ $t("language.clear") }}</v-btn
                          >
                        </v-card-actions>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card>
              </v-form>
            </ValidationObserver>
            <ValidationObserver
              ref="form"
              v-slot="{ passes }"
              v-if="models.length > 0"
            >
              <v-form @submit.prevent="passes(save)">
                <v-card>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm12 md12>
                          <v-simple-table>
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">
                                    {{ $t("language.person") }}
                                  </th>
                                  <th class="text-left">
                                    {{ $t("language.date") }}
                                  </th>
                                  <th class="text-left">
                                    {{ $t("language.day") }}
                                  </th>
                                  <th class="text-left">
                                    {{ $t("language.workinghourtime") }}
                                  </th>
                                  <th class="text-left">
                                    {{ $t("language.intime") }}
                                  </th>
                                  <th class="text-left">
                                    {{ $t("language.outtime") }}
                                  </th>
                                  <th class="text-left">
                                    {{ $t("language.workedhour") }}
                                  </th>                                  
                                  <!-- <th class="text-left">
                                    {{ $t("language.othours") }}
                                  </th> -->
                                  <th class="text-left">
                                    {{ $t("language.otminutes") }}
                                  </th>
                                  <th class="text-left">
                                    {{ $t("language.select") }}
                                    <v-switch v-model="selectAll"></v-switch>
                                  </th>
                                  <th class="text-left">
                                    {{ $t("language.remarks") }}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(item, index) in models"
                                  :key="index"
                                >
                                  <td>{{ item.person }}</td>
                                  <td>{{ getDefaultDate(item.date) }}</td>
                                  <td>{{ item.day }}</td>
                                  <td>{{ item.workinghourtime }}</td>
                                  <td>{{ item.intime }}</td>
                                  <td>{{ item.outtime }}</td>
                                  <td>{{ item.workedhour }}</td>
                                  
                                  <!-- <td>{{ item.otapprovedhour }}</td> -->
                                  <td>
                                    <ValidationProvider
                                      :name="$t('language.otminutes')"
                                      :rules="item.select ? 'required|numeric' : ''"
                                      v-slot="{ errors }"
                                    >
                                      <v-text-field
                                        v-model="item.otapprovedminutes"
                                        :label="$t('language.otminutes')"
                                        :error-messages="errors[0]"
                                      />
                                    </ValidationProvider>
                                  </td>
                                  <td>
                                    <v-switch v-model="item.select" :disabled="item.isapproved"></v-switch>
                                  </td>
                                  <td>
                                    <ValidationProvider
                                      :name="$t('language.remarks')"                                      
                                      v-slot="{ errors }"
                                    >
                                      <v-textarea
                                        dense
                                        v-model="item.otremarks"
                                        :label="$t('language.remarks')"
                                        :error-messages="errors[0]"
                                        rows="1"
                                      ></v-textarea>
                                    </ValidationProvider>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="blue darken-1" text type="submit">{{
                      $t("language.save")
                    }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </ValidationObserver>
          </material-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import EngNepDatePicker from "../../../components/shared/EngNepDatePicker";
import Base from "../../../shared/Base.vue";
import commonservice from "../../../shared/common.service";
export default {
  name: "overtimeview",
  extends: Base,
  components: {
    EngNepDatePicker,
  },
  data() {
    return {
      filter: {},
      panel: [1],
      DepartmentList: [],
      BranchList: [],
      PersonList: [],
      models: [],
      selectAll : false
    };
  },
  watch: {
    "selectAll": {
      handler() {
        this.models = this.models.map((item) => {
            if(!item.isapproved){
              item.select = this.selectAll;
            }
            return item;
          });
      },
    }
  },
  created() {
    this.panel = [...Array(1).keys()].map((k, i) => i);
    this.url = "client/posting/overtimes";
    this.resetFilter();
  },
  beforeRouteEnter(to, from, next) {
    axios.get("client/posting/overtimes/init/list").then((response) => {
      next((p) => {
        p.DepartmentList = response.data.departments;
        p.BranchList = response.data.branches;
        p.PersonList = response.data.persons;
      });
    });
  },
  methods: {
    resetFilter() {
      this.filter = {
        fromdate: moment().format("YYYY-MM-DD"),
        todate: moment().format("YYYY-MM-DD"),
        branchid: null,
        departmentid: null,
        personid: null,
      };
    },
    filterdata() {
      axios
        .get(
          "client/posting/overtimes?" + this.convertToQueryString(this.filter)
        )
        .then((response) => {
          this.models = response.data.map((item) => {
            item.select = item.isapproved;
            return item;
          });
          this.isEdit = true;
          if (this.models.length == 0) {
            this.$store.dispatch(
              "showErrorMessage",
              this.$t("language.nodatafound")
            );
          }
        });
    },
    beforeSave() {
      this.vModel = this.models
        .filter((item) => {
          return item.select;
        })
        .map((item) => {
          return {
            id: item.id,
            otremarks: item.otremarks,
            otapprovedminutes: item.otapprovedminutes,
          };
        });
      if (this.vModel.length > 0) return true;
      return false;
    },
  },
};
</script>
